import axios from 'axios';
  const token = localStorage.getItem('token');


  const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const fetchStudentData = async () => {
  try {
    const response = await axios.get(`${BACKEND}/students`,{
      headers: {
        Authorization: `Bearer ${token}`, // Send token as a Bearer token
      },
    }      );
    return response.data.students; 
  } catch (error) {
    throw new Error('Error fetching student data');
  }
};

export const verifyStudent = async (studentId) => {
  try {
    const response = await axios.put(`${BACKEND}/students/${studentId}/verify`,  {}, 

      {
        headers: {
          Authorization: `Bearer ${token}`, // Send token as a Bearer token
        },
      }      
    );

    return response.data;

  } catch (error) {
    throw new Error('Error verifying student');
  }
};

export const verifyStudentRequest = async (studentId,requestId) => {
  try {
    const response = await axios.put(`${BACKEND}/students/${studentId}/${requestId}/verify`,  {}, 
      {
        headers: {
          Authorization: `Bearer ${token}`, // Send token as a Bearer token
        },
      }      
    );
    console.log(response)

    return response.data;

  } catch (error) {
    console.log(error)

    throw new Error('Error verifying student');
  }
};


export const getverifyrequest = async () => {
  try {
    const response = await axios.get(`${BACKEND}/getverify`
      // {
      //   headers: {
      //     Authorization: `Bearer ${token}`, // Send token as a Bearer token
      //   },
      // }      
    );

    return response.data;

  } catch (error) {
    throw new Error('Error getting verifying requests');
  }
};


export const addStudent = async (formData,feesData) => {
  console.log(token,formData,feesData)
  try {
    const response = await axios.post(`${BACKEND}/addStudentFromAdmin`,
      { ...formData, feesData },       {
        // headers: {
        //   Authorization: `Bearer ${token}`, // Send token as a Bearer token
        // },
      }      
    );
    return response.data;  
  } catch (error) {
    throw new Error(error.response ? error.response.data.message : 'Error during add student');
  }
};

export const editStudent = async (studentId, updatedData,feesData) => {
  try {
    const response = await axios.put(`${BACKEND}/edit/${studentId}`, 
      { ...updatedData, feesData }
      // headers: {
      //   Authorization: `Bearer ${token}`, // Send token as a Bearer token
      // },
     );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Error updating student');
  }
};

export const deleteStudent = async (studentId) => {
  try {
    const response = await fetch(`${BACKEND}/delete/${studentId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`, // Send token as a Bearer token

      },
    });

    if (!response.ok) {
      throw new Error('Failed to delete student');
    }

    const data = await response.json();
    return data;  // Response from the server (success message, etc.)
  } catch (error) {
    throw new Error(error.message || 'Error deleting student');
  }
};

export const fetchBatches = async (academyId) => {
  try {
    const response = await axios.get(`${BACKEND}/getBatchForAdmin/${academyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      console.log("response.data",response.data)
    return response.data;
  } catch (error) {
    throw new Error('Error fetching academy data');
  }
};


export const fetchBatchesForCoach = async (academyId,sport) => {
  // console.log(`${BACKEND}/getBatchForCoachAdd/${academyId}/${sport}`)
  try {
    const response = await axios.get(`${BACKEND}/getBatchForCoachAdd/${academyId}/${sport}`,
      {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      console.log("response.data",response.data)
    return response.data;
  } catch (error) {
    throw new Error('Error fetching academy data');
  }
};


